// BOLDE-owned (house) — safe to edit on the draft; follow lp/docs/NAMING-STANDARD.md.
/* BOLDE-owned (house) — Sale image campaigns, in the browser. Two jobs, one file (lp/docs/SALE-IMAGE-CAMPAIGNS.md):
   1. GUARD. Shopify can serve a saved copy of a page for many minutes (measured 1 to 15+), and Liquid's "now" is the
      time of the last render, so a page can outlive a campaign's end (or miss its start). When a campaign is live or
      starts within 30 minutes, the buy-box block prints its times and photos (script[data-lp-sale-guard]) plus each
      color's original first photo (script[data-lp-sale-orig]) and loads this file. We compare the campaign's
      start/end with the browser's clock and put the right first photo back or in. When the page is already right
      (the normal case) nothing at all changes.
   2. PREVIEW. Loaded only for a link with ?campaign=<handle> (data-campaign on this script's tag): fetch that
      campaign through the Section Rendering API (sections/bolde-sale-preview.liquid) and show it whatever its switch
      or dates say.
   Matching is by variant id: a photo row is [[variant id], url, w, h] and a gallery's data-id IS its variant id.
   (The theme turns each bottle's color pickers into those rows; see snippets/bolde-sale-campaign.liquid.)
   Photos are placed in built galleries (img src/srcset/size) and in the lazy-gallery JSON (script[data-lp-gallery-data])
   that lp-buybox's script builds slides from. The shop clock of a visitor can be wrong; that only moves the moment of
   the flip, never what is shown outside the campaign's window on a correct clock. */
(function () {
  'use strict';
  var me = document.currentScript;
  var previewHandle = me && me.getAttribute('data-campaign');
  var SIZES = '(min-width: 990px) 600px, (min-width: 679px) 50vw, 100vw';
  /* fallback only: the page prints the real ones (script[data-lp-gallery-data] data-thumb-sizes), which depend on the
     gallery layout (snippets/lp-buybox-gallery). Same side-layout values as there. */
  var THUMB_SIZES = '(min-width: 991px) 80px, (min-width: 679px) 60px, 40px';
  function thumbSizes() {
    var s = document.querySelector('script[data-lp-gallery-data][data-thumb-sizes]');
    return (s && s.getAttribute('data-thumb-sizes')) || THUMB_SIZES;
  }
  function altOf(id) {
    var g = document.querySelector('.bb-product_gallery_flex[data-id="' + id + '"]');
    return (g && g.getAttribute('data-lp-alt')) || '';
  }

  function at(url, w) { return String(url).replace(/([?&]width=)\d+/, function (m, k) { return k + w; }); }
  function file(u) { return String(u || '').split('?')[0].split('/').pop(); }
  function read(sel) {
    var out = [];
    Array.prototype.forEach.call(document.querySelectorAll(sel), function (s) {
      try { out.push(JSON.parse(s.textContent)); } catch (e) {}
    });
    return out;
  }
  /* One slide, same markup as snippets/lp-buybox-gallery-slide. A thumbnail (w = 240) gets the 80/160/240 srcset, the
     thumbnail sizes and alt="" (the strip repeats the stage photos); the stage photo gets the gallery's alt text
     ("<product> – <color>"), since a campaign photo has no alt of its own here. */
  function slide(url, w, iw, ih, sizes, alt) {
    var thumb = w === 240;
    var img = document.createElement('img');
    img.setAttribute('src', at(url, w)); img.setAttribute('alt', thumb ? '' : (alt || ''));
    img.setAttribute('srcset', (thumb ? [80, 160, 240] : [400, 600, 900, 1200]).map(function (x) { return at(url, x) + ' ' + x + 'w'; }).join(', '));
    img.setAttribute('width', w); img.setAttribute('height', Math.round(w * ih / iw)); img.setAttribute('loading', 'lazy');
    if (thumb) img.setAttribute('sizes', thumbSizes()); else if (sizes) img.setAttribute('sizes', sizes);
    return '<div class="swiper-slide">' + img.outerHTML + '</div>';
  }

  /* the photo each variant should show at nowSec: { id: {url,w,h,thumb} | null (= the original) } */
  function wanted(cands, nowSec) {
    var out = {};
    Array.prototype.forEach.call(document.querySelectorAll('.bb-product-color_box[data-id]'), function (box) {
      var id = box.getAttribute('data-id');
      var win = null;
      cands.forEach(function (c) {
        if (nowSec < c.s || (c.e && nowSec >= c.e)) return;
        c.p.forEach(function (r) {
          if (r[0].indexOf(id) !== -1) win = { url: r[1], w: r[2], h: r[3], thumb: c.t };
        });
      });
      out[id] = win;
    });
    return out;
  }

  function place(want, orig) {
    var changed = 0;
    var dataScripts = document.querySelectorAll('script[data-lp-gallery-data]');
    Array.prototype.forEach.call(dataScripts, function (s) {
      var map;
      try { map = JSON.parse(s.textContent); } catch (e) { return; }
      var dirty = false;
      Object.keys(map).forEach(function (id) {
        if (!(id in want) || !map[id].length) return;
        var w = want[id], o = orig[id], cur = map[id][0], main, keepThumb = false;
        if (w) { main = w; keepThumb = !w.thumb && o; }
        else if (o) { main = { url: o[0], w: o[1], h: o[2] }; }
        else return;
        if (cur[0] === 'i' && file(cur[1]) === file(main.url) && !keepThumb) return;
        if (cur[0] === 'v') return;
        map[id][0] = keepThumb
          ? ['h', slide(o[0], 240, o[1], o[2]), slide(main.url, 1200, main.w, main.h, s.getAttribute('data-sizes') || SIZES, altOf(id))]
          : ['i', main.url, main.w, main.h];
        dirty = true; changed++;
      });
      if (dirty) s.textContent = JSON.stringify(map);
    });
    Object.keys(want).forEach(function (id) {
      var g = document.querySelector('.bb-product_gallery_flex[data-id="' + id + '"]');
      if (!g || g.hasAttribute('data-lp-lazy')) return;
      var w = want[id], o = orig[id];
      var main = w || (o && { url: o[0], w: o[1], h: o[2] });
      if (!main) return;
      var stage = g.querySelector('.main-gallery .swiper-slide img');
      if (stage && file(stage.getAttribute('src')) !== file(main.url)) {
        var sizes = stage.getAttribute('sizes') || SIZES;
        stage.setAttribute('srcset', [400, 600, 900, 1200].map(function (x) { return at(main.url, x) + ' ' + x + 'w'; }).join(', '));
        stage.setAttribute('src', main.url);
        stage.setAttribute('width', 1200);
        stage.setAttribute('height', Math.round(1200 * main.h / main.w));
        stage.setAttribute('sizes', sizes);
        stage.setAttribute('alt', altOf(id) || stage.getAttribute('alt') || '');
        changed++;
      }
      var thumb = g.querySelector('.gallery-thumbs .swiper-slide img');
      var tsrc = (w && w.thumb) ? w : (o && { url: o[0], w: o[1], h: o[2] });
      if (thumb && tsrc && file(thumb.getAttribute('src')) !== file(tsrc.url)) {
        thumb.setAttribute('srcset', [80, 160, 240].map(function (x) { return at(tsrc.url, x) + ' ' + x + 'w'; }).join(', '));
        thumb.setAttribute('src', at(tsrc.url, 240));
        thumb.setAttribute('height', Math.round(240 * tsrc.h / tsrc.w));
        changed++;
      }
    });
    return changed;
  }

  /* lp-buybox's script copies the lazy-gallery JSON into memory when it starts, before this file runs, so editing the
     JSON cannot reach a stub that is built later. A stub is built by emptying data-lp-lazy; when that happens we fix
     its first slide in the DOM (a microtask, before the browser lays it out, so a lazy image has not started loading). */
  var state = { want: {}, orig: {} };
  function watchStubs() {
    if (!window.MutationObserver) return;
    var stubs = document.querySelectorAll('.bb-product_gallery_flex[data-lp-lazy]');
    if (!stubs.length) return;
    var ob = new MutationObserver(function (records) {
      records.forEach(function (r) {
        var id = r.target.getAttribute('data-id');
        if (r.target.hasAttribute('data-lp-lazy') || !(id in state.want)) return;
        var one = {}; one[id] = state.want[id];
        place(one, state.orig);
      });
    });
    Array.prototype.forEach.call(stubs, function (g) { ob.observe(g, { attributes: true, attributeFilter: ['data-lp-lazy'] }); });
  }

  function flag(text) {
    var bar = document.createElement('div');
    bar.setAttribute('role', 'status');
    bar.setAttribute('data-lp-sale-note', '');
    bar.style.cssText = 'position:fixed;left:12px;bottom:56px;z-index:2147483000;background:#131415;color:#fff;font:600 13px/1.3 system-ui,sans-serif;padding:8px 12px;border-radius:8px;box-shadow:0 2px 10px rgba(0,0,0,.3);max-width:80vw';
    bar.textContent = text;
    document.body.appendChild(bar);
  }

  function guard() {
    var cands = [].concat.apply([], read('script[data-lp-sale-guard]'));
    var orig = {};
    read('script[data-lp-sale-orig]').forEach(function (m) { for (var k in m) orig[k] = m[k]; });
    if (!cands.length) return;
    state.orig = orig;
    watchStubs();
    function run() {
      var now = Date.now() / 1000;
      state.want = wanted(cands, now);
      place(state.want, orig);
      var next = 0;
      cands.forEach(function (c) { [c.s, c.e].forEach(function (t) { if (t > now && (!next || t < next)) next = t; }); });
      if (next && next - now < 3600) setTimeout(run, (next - now) * 1000 + 500);
    }
    run();
  }

  function preview() {
    var url = '/search?q=' + encodeURIComponent(previewHandle) + '&sections=bolde-sale-preview';
    fetch(url, { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (json) {
      var m = /<script type="application\/json" data-bolde-sale-preview>([\s\S]*?)<\/script>/.exec(json['bolde-sale-preview'] || '');
      var data = m ? JSON.parse(m[1].trim()) : null;
      if (!data) { flag('Sale campaign preview: no campaign with the handle "' + previewHandle + '".'); return; }
      var cand = { s: 0, e: 0, t: data.thumb ? 1 : 0, p: data.photos };
      var orig = {};
      read('script[data-lp-sale-orig]').forEach(function (map) { for (var k in map) orig[k] = map[k]; });
      var want = wanted([cand], 1);
      state.want = want; state.orig = orig;
      watchStubs();
      var n = Object.keys(want).filter(function (k) { return want[k]; }).length;
      place(want, orig);
      flag('Previewing: ' + data.name + ' (' + n + ' bottles swapped; shows ' + (data.where || 'everywhere') + '). Remove ?campaign= from the link to go back.' + (data.notes && data.notes.length ? ' Notes: ' + data.notes.join('. ') + '.' : ''));
    }).catch(function () { flag('Sale campaign preview could not load "' + previewHandle + '".'); });
  }

  function start() {
    if (previewHandle && me.getAttribute('data-off')) { flag('Sale photos are switched off on this page (the buy box setting "Use sale image campaigns" is off), so no campaign shows here.'); return; }
    if (previewHandle) preview(); else guard();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
